import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { selectors } from 'src/store';
import Container from 'src/components/pages/Activities/FlashCards/Levels/Container';

const FlashCardsStepThreeLevels = ({
  currency,
  levels,
  getLevelsByCollectionId,
  hasLoaded,
  ...props
}) => {
  useEffect(() => {
    getLevelsByCollectionId();
  }, [getLevelsByCollectionId]);

  return (
    <Container
      className="flash-cards-levels-container--step-three"
      currency={currency}
      hasLoaded={hasLoaded}
      items={levels}
      {...props}
    />
  );
};

FlashCardsStepThreeLevels.propTypes = {
  currency: PropTypes.shape({}),
  levels: PropTypes.arrayOf(PropTypes.shape({})),
  getLevelsByCollectionId: PropTypes.func.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
};

FlashCardsStepThreeLevels.defaultProps = {
  currency: null,
  levels: [],
};

const mapStateToProps = (state) => ({
  hasLoaded: selectors.dailyMap.getHasLoadedLevels(state),
  currency: selectors.dailyMap.getDailyMapCollection(state)?.currency,
  levels: selectors.dailyMap.getDailyMapCollection(state)?.levels,
});

const mapDispatchToProps = {};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  memo
)(FlashCardsStepThreeLevels);
